import { render, staticRenderFns } from "./EventInfo.vue?vue&type=template&id=8a64b38a"
import script from "./EventInfo.vue?vue&type=script&lang=js"
export * from "./EventInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports